import { CheckCheck, Check, Clock, AlertCircle } from "lucide-react";

export const StatusIcon = ({ status }) => {
  if (status === "read")      return <CheckCheck className="w-3.5 h-3.5 text-blue-400" />;
  if (status === "delivered") return <CheckCheck className="w-3.5 h-3.5 text-gray-400" />;
  if (status === "sent")      return <Check className="w-3.5 h-3.5 text-gray-400" />;
  if (status === "sending")   return <Clock className="w-3.5 h-3.5 text-gray-400" />;
  if (status === "failed")    return <AlertCircle className="w-3.5 h-3.5 text-red-400" />;
  return null;
};

export const StatusBadge = ({ status }) => {
  const styles = {
    open:     "bg-green-100 text-green-700",
    resolved: "bg-gray-100 text-gray-600",
    waiting:  "bg-yellow-100 text-yellow-700",
  };
  return (
    <span className={`text-xs px-2 py-0.5 rounded-full font-medium capitalize ${styles[status] || "bg-gray-100 text-gray-600"}`}>
      {status}
    </span>
  );
};
